import { SVGIconProps } from './types/types';
import classNames from 'classnames';

const TickOutline = ({ width = 20, height = 20, className }: SVGIconProps) => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    className={classNames(className)}
    width={width}
    height={height}
    viewBox='0 0 20 20'
  >
    <g fill='none' fillRule='evenodd'>
      <circle cx='10' cy='10' r='8.5' />
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M7 10l2 2 3.995-4'
      />
    </g>
  </svg>
);

export default TickOutline;
